import { useDataGrid } from "../DataGridProvider";

export interface TDataGridTableBodyRowSelectProps<TData> {
  data: TData;
}

const DataGridTableBodyRowSelect = <TData,>({
  data,
}: TDataGridTableBodyRowSelectProps<TData>) => {
  const { selectedRows, toggleRowSelection } = useDataGrid();

  const isSelected = selectedRows.find(
    (row) => JSON.stringify(row) === JSON.stringify(data),
  );

  return (
    <td>
      <input
        type="checkbox"
        className="checkbox checkbox-sm"
        checked={isSelected}
        onChange={() => toggleRowSelection(data)}
      />
    </td>
  );
};

export { DataGridTableBodyRowSelect };
